<template>
  <div>
    <b-modal
      v-show="!modalLoader"
      id="modal-role"
      ref="modal-role"
      cancel-variant="outline-secondary"
      :ok-title="bTitle"
      cancel-title="Close"
      centered
      title="Role Management"
      size="lg"
      @ok="handleSubmit"
      @hidden="resetModal"
      @shown="onModalShown"
    >
      <b-overlay
        id="overlay-background"
        :show="modalLoader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-form ref="roleForm">
          <b-form-group>
            <label for="translationKey">Title</label>
            <b-form-input
              id="translationKey"
              v-model="roleDetails.title"
              type="text"
              placeholder="Title"
            />
            <small
              class="text-danger"
              :v-show="showValidationMsg === true"
            >{{ vMsg }}</small>
          </b-form-group>
          <!-- PERMISSION TABLE -->
          <b-card
            no-body
            class="border mt-1"
          >
            <b-card-header class="p-1">
              <b-card-title class="font-medium-2">
                <feather-icon
                  icon="LockIcon"
                  size="18"
                />
                <span class="align-middle ml-50">{{ $t('DEBTIA_PERMISSIONS') }}</span>
              </b-card-title>
            </b-card-header>
            <b-table
              v-if="!loader"
              striped
              responsive
              class="mb-0"
              :items="permissionsData"
            >
              <template #cell(module)="data">
                {{ data.value }}
              </template>
              <template #cell()="data">
                <b-form-checkbox
                  v-model="selected"
                  :checked="data.value"
                  :value="data.value"
                />
              </template>
            </b-table>
          </b-card>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BOverlay, BFormGroup, BForm, BFormInput, BCard, BTable, BCardHeader, BCardTitle,
  BFormCheckbox,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BModal,
    BOverlay,
    BFormGroup,
    BForm,
    BFormInput,
    BCard,
    BTable,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
  },
  props: {
    roleData: {
      type: Object,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    buttonTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modalLoader: false,
      loader: true,
      permissionsData: [],
      selected: [],
      roleDetails: {},
      headingArray: [],
      bTitle: '',
      showValidationMsg: false,
      vMsg: '',
    }
  },
  watch: {
    selected: {
      deep: true,
      handler() {
        // console.log('Selected permissions changed', newValue)
      },
    },
    roleData: {
      handler() {
        this.roleDetails = { ...this.roleData }
        // this.selected = this.roleDetails.permissions
        this.bTitle = this.buttonTitle
        this.showValidationMsg = false
        this.vMsg = ''
      },
    },
  },
  created() {
    this.getPermissions()
  },
  methods: {
    onModalShown() {
      this.getRecordPermissions()
      if (this.$refs.roleForm && this.roleDetails.id === 0) {
        this.$refs.roleForm.reset()
      }
    },
    async handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()
      const data = []
      data.id = this.roleDetails.id
      data.title = this.roleDetails.title

      if (data.title === '') {
        this.showValidationMsg = true
        this.vMsg = 'Title field is required'
        // bvModalEvt.preventDefault()
        return
      }
      const permissions = []

      this.headingArray.forEach(heading => {
        // console.log('heading', heading)
        const result = this.selected.filter(word => word.includes(heading))
        const assignedPermissions = []
        result.forEach(item => {
          const ret = item.replace(`${heading}_`, '')
          assignedPermissions.push(ret)
        })
        permissions.push({ assignedPermissions, heading })
      })
      data.permissions = permissions

      // console.log('data', { ...data })
      await axios.post('role-management/save', { ...data })
        .then(response => {
          this.showValidationMsg = false
          this.vMsg = ''
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Role Management',
              icon: 'CoffeeIcon',
              variant: 'success',
              text: response.data.message,
            },
          })
          this.$bvModal.hide('modal-role')
          this.reloadMethod()
        }).catch(error => {
          this.showValidationMsg = true
          this.vMsg = error.response.data.message
          // bvModalEvt.preventDefault()
          // eslint-disable-next-line no-useless-return
          return
        })
    },
    async getRecordPermissions() {
      this.modalLoader = true
      const data = await axios.get('role-management/get-role-abilities', { params: { role: this.roleData.name } })
      if (data.status === 200) {
        this.selected = data.data.data
        this.modalLoader = false
      }
    },
    resetModal() {
      this.showValidationMsg = false
      this.vMsg = ''
    },
    async getPermissions() {
      const newArr = []
      axios
        .get('/role-management/default-permissions')
        .then(response => {
          const headingData = Object.keys(response.data.data)
          this.headingArray = headingData
          let newObj = null
          headingData.forEach(element => {
            newObj = response.data.data[element]
            delete newObj.model
            newArr.push(newObj)
          })
          this.permissionsData = newArr
          this.loader = false
        })
        .catch(error => console.log('ERROR', error))
    },
  },
}
</script>

<style>

</style>
